import styled from 'styled-components';
import { defaultTheme } from '../core/theme';

export const H4 = styled.h4`
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.2;
  color: ${defaultTheme.colors.black};
`;
